import styled from "styled-components";

export const StyledTechListContainer = styled.div`
  width: 100%;
`;

export const StyledTechList = styled.ul`
  background-color: var(--color-gray-3);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
  padding: 2rem;
  margin-top: 2rem;
`;

export const StyledHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  h2 {
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
  }
`;
